import React, {useEffect, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {clearSession, getCookie} from '../api';

function getInitials() {
  const name = decodeURIComponent(getCookie('displayName') || '');
  if (!name) return 'U';
  const parts = name.split(/\s+/).filter(Boolean);
  return parts.length >= 2 ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase() : parts[0][0].toUpperCase();
}

export default function UserMenu({ color = 'bg-gray-600' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleLogout = () => {
    clearSession();
    navigate('/login');
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen(!open)}
        className={`w-10 h-10 ${color} rounded-full flex items-center justify-center text-white hover:opacity-80 transition-opacity text-sm font-medium`}>
        {getInitials()}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200">
          <a href="/settings" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Settings</a>
          <a href="/tenants" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Switch Organization</a>
          <button onClick={handleLogout} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Sign Out</button>
        </div>
      )}
    </div>
  );
}
